"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _shortid = _interopRequireDefault(require("shortid"));

var _propTypes = require("prop-types");

var _SandboxMapLegend = _interopRequireDefault(require("./SandboxMapLegend"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n                    text-align: center;\n                  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SandboxLegend = function SandboxLegend(props) {
  var foundationData = props.foundationData,
      allSlides = props.allSlides,
      foundationMapProps = props.foundationMapProps,
      areSlidesLoading = props.areSlidesLoading,
      errors = props.errors;
  var loader = (0, _core.jsx)("div", null);
  return (0, _core.jsx)("div", null, !areSlidesLoading && allSlides ? allSlides.map(function (slide) {
    var dataIndex = foundationData.findIndex(function (d) {
      var scatterplot = d.mapType === "ScatterPlotMap" && d.layerInfo.displayName === slide.label;
      var choropleth = d.mapType === "ChoroplethMap" && d.layerInfo.displayName === slide.label;
      var vectorTilesMap = d.mapType === "vtChoroplethMap" && d.legend && d.layerInfo.displayName === slide.label;
      var vtScatterPlotMap = d.mapType === "vtScatterPlotMap" && d.legend && d.layerInfo.displayName === slide.label;
      return choropleth || scatterplot || vectorTilesMap || vtScatterPlotMap;
    });
    var matchFound = dataIndex > -1 && foundationData[dataIndex].data.length > 0;
    var mapLegend = matchFound && (0, _core.jsx)(_SandboxMapLegend["default"], {
      data: foundationData[dataIndex].data,
      mapProps: foundationMapProps[dataIndex]
    });
    var matchFoundVector = dataIndex > -1 && foundationData[dataIndex].mapType === "vtChoroplethMap" || dataIndex > -1 && foundationData[dataIndex].mapType === "vtScatterPlotMap";
    var mapLegendVector = matchFoundVector && (0, _core.jsx)(_SandboxMapLegend["default"], {
      mapProps: foundationMapProps[dataIndex]
    });
    var mapLegendBox = (matchFound || matchFoundVector) && (0, _core.jsx)("div", null, (0, _core.jsx)("h3", {
      css: (0, _core.css)(_templateObject())
    }, slide.label), mapLegend, mapLegendVector);
    return (0, _core.jsx)("div", {
      key: _shortid["default"].generate(),
      css: (0, _core.css)("\n                  position: absolute;\n                  bottom: ".concat(30 + dataIndex * 150, "px;\n                  width: 500px;\n                  left: 0px;\n                  background-color: rgba(255,255,255,0.9);\n                  @media (max-width: 500px) {\n                    width: 100%\n                  }\n                "))
    }, mapLegendBox);
  }) : loader, errors ? (0, _core.jsx)("div", {
    css: (0, _core.css)("\n                margin: auto;\n                width: 80%;\n              ")
  }, (0, _core.jsx)("p", null, "There was an error fetching the data.")) : null);
};

var _default = SandboxLegend;
exports["default"] = _default;
SandboxLegend.propTypes = {
  foundationData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  allSlides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  foundationMapProps: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  areSlidesLoading: _propTypes.bool,
  errors: _propTypes.bool
};